import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-close-asker',
  templateUrl: './dialog-close-asker.component.html',
  styleUrls: ['./dialog-close-asker.component.css']
})
export class DialogCloseAskerComponent implements OnInit {

  title = '';
  subtitle = '';

  constructor(
    @Inject(MD_DIALOG_DATA) data,
    private dialogRef: MdDialogRef<DialogCloseAskerComponent>
  ) {
    this.title = data.title;
    this.subtitle = data.subtitle;
   }

  ngOnInit() {
  }

  closeDialogRef(exit: boolean) {
    this.dialogRef.close(exit);
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/dialog-close-asker/dialog-close-asker.component.ts